var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"NotFound"},[_c('p',{staticClass:"NotFound-copy"},[_vm._v("\n        404\n        "),_c('br'),_vm._v("\n        Página no encontrada\n        "),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("\n            Inicio\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75539890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/NotFound.vue
// module id = null
// module chunks = 